import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  accessCode: Yup.string()
    .test(
      "length",
      "Access code should contain 6 numbers",
      val => val?.replace(/\D/g, "").length === 6,
    )
    .required(),
});

export default validationSchema;
